module.exports = __webpack_public_path__ + "img/sintesis.d58e3db6.svg";